







































































import {
  Component,
  Vue,
  Watch,
} from 'vue-property-decorator';
import IntegrationsService from '../../services/integrations.service';
import {Integration, IntegrationOutputType} from '@/types';
import { Action, Getter, Mutation } from 'vuex-class';
import IntegrationIcon from '@/components/IntegrationIcon.vue';
import IntegrationsList from '@/components/IntegrationsList.vue';
import RemoveIntegrationModal from '@/components/RemoveIntegrationModal.vue';
import Spinner from '@/components/Spinner.vue';

@Component({
  components: {
    IntegrationIcon,
    IntegrationsList,
    RemoveIntegrationModal,
    Spinner,
  },
})
export default class Integrations extends Vue {
  @Getter private hasPermission: any;

  private readonly IntegrationOutputType = IntegrationOutputType;
  private integrations: any[] = [];
  private bulkIntegrations: any[] = [];

  private integrationToDelete: Integration | null = null;

  private showModalConfirm: boolean = false;
  private preventConfirm: boolean = false;
  private modalHeader: string = '';
  private modalBody: string = '';
  private handleModalConfirm: any = null;

  private loading: boolean = false;

  private notificationIntegrationTypes: object[] = [
    { title: 'Webhook', type: 'webhook', icon: 'mdi-webhook'},
    { title: 'Slack', type: 'slack', icon: 'mdi-slack'},
    { title: 'Email', type: 'email', icon: 'mdi-email'},
    { title: 'MQTT', type: 'mqtt', icon: 'mdi-aws'},
    { title: 'Websocket', type: 'websocket', icon: 'mdi-power-plug' },
    { title: 'Node Red', type: 'awsiot', icon: 'mdi-aws' },
    { title: 'BACnet', type: 'bacnet', icon: 'mdi-lan' },
  ];

  private bulkIntegrationTypes: object[] = [
    { title: 'Azure Data Lake', type: 'azureDataLake', icon: 'mdi-database'},
    // { title: 'Azure Blob', type: 'azure-blob', icon: 'mdi-database'},
    // { title: 'Azure SQL Server', type: 'azure', icon: 'mdi-database'},
    { title: 'SFTP', type: 'sftp', icon: 'mdi-database'},
    { title: 'AWS S3 Bucket', type: 's3', icon: 'mdi-aws' },
    { title: 'Quicksight S3', type: 'qss3', icon: 'mdi-bucket' },
  ];

  private async mounted() {
    try {
      this.loading = true;
      await this.populateIntegrations();
    } finally {
      this.loading = false;
    }
  }

  private async populateIntegrations() {
    const integrations = await IntegrationsService.getIntegrations();
    const notificationIntegrations: Integration[] = [];
    const exportIntegrations: Integration[] = [];
    integrations.forEach((integration: Integration) => {
      if (integration.output_type === IntegrationOutputType.PUBLISHING) {
        exportIntegrations.push(integration);
      } else {
        notificationIntegrations.push(integration);
      }
    });

    this.integrations = notificationIntegrations;
    this.bulkIntegrations = exportIntegrations;
  }

  private deleteIntegration(index: number, bulkIntegration: boolean = false) {
    this.integrationToDelete = bulkIntegration ? this.bulkIntegrations[index] : this.integrations[index];
    this.showModalConfirm = true;
  }

  private editIntegration(integration: Partial<Integration>, index: number, isBulkIntegration: boolean = false) {
    Vue.set(isBulkIntegration ? this.bulkIntegrations : this.integrations, index, integration);
  }

  private async toggleEnabled(index: number, bulkIntegration: boolean = false) {
    const integrationToUpdate = bulkIntegration ? this.bulkIntegrations[index] : this.integrations[index];
    if (integrationToUpdate.id) {
      await IntegrationsService.updateIntegration(integrationToUpdate);
      await this.populateIntegrations();
    }
  }

  private async deleteUnusedIntegration(selected: Integration) {
    if (selected.id) {
      await IntegrationsService.deleteIntegration(selected.id);
      this.populateIntegrations();
    } else {
      this.integrations = this.integrations.filter((integration: Integration ) => integration !== selected);
      this.bulkIntegrations = this.bulkIntegrations.filter((integration: Integration ) => integration !== selected);
    }

    this.integrationToDelete = null;
  }
}
